.illustration {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  margin: 0 auto;
  padding: 0 1.5rem 2.5rem;
}
